// eslint-disable-next-line no-unused-vars
import { IModel } from '@src/js/separate-logic/interface/IModel';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { ISlideBaseAppServices } from '@src/slide/application/entry/toc/base/slide-base-app-services.interface';

export default class ShapeLinkFlagModel implements IModel {
    private show: boolean;
    private modelStateCroping: boolean;
    public initModel(props: any) {
        this.show = !!props.data;
        this.modelStateCroping = this.getEditingStateManager().isCroping;
    }

    private getEditingStateManager() {
        return (AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices)
            .viewableServiceLayer.editingStateManager;
    }
}
